import { ACCOMMODATIONS_COMPARATOR_ADD_COMPARATOR, ACCOMMODATIONS_COMPARATOR_REMOVE_COMPARATOR } from'./../actions/actionTypes';
import { ACCOMMODATIONS_COMPARATOR_SET_REGION, ACCOMMODATIONS_COMPARATOR_SET_DATA_TYPE } from'./../actions/actionTypes';

import cloneDeep from 'lodash/cloneDeep';

const newComparatorState = () => {
    return {
        region: 'all',
        dataType: 'all'
    }
}

const initialState = {
    comparators: [newComparatorState()]
};

function reducer(state = initialState, action) {
    let nextState = cloneDeep(state);

    switch (action.type) {
        case ACCOMMODATIONS_COMPARATOR_ADD_COMPARATOR: {
            if(nextState.comparators.length < 2) nextState.comparators.push(newComparatorState())
            return nextState;
        }
        case ACCOMMODATIONS_COMPARATOR_REMOVE_COMPARATOR: {
            if(nextState.comparators.length > 1) nextState.comparators.pop()
            return nextState;
        }
        case ACCOMMODATIONS_COMPARATOR_SET_REGION: {
            nextState.comparators[action.comparatorIndex].region = action.region
            return nextState;
        }
        case ACCOMMODATIONS_COMPARATOR_SET_DATA_TYPE: {
            nextState.comparators[action.comparatorIndex].dataType = action.dataType
            return nextState;
        }
        default: {
            return state;
        }
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/accommodationsComparator.js